import React from "react"
import styled from "styled-components"

import Flex from "../../Flex"
import {Body} from "../../Typography"
import Icon, {IconTypes} from "../../Icon"

export const StyledLabel = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  text-transform: initial;
`

interface RowProps {
  isFocused: boolean
  isDisabled?: boolean
}

export const FlexRow = styled(Flex)<RowProps>`
  background-color: ${({theme, isFocused}) => (isFocused ? theme.colors.utility.highlight : "none")};
  padding: ${({theme}) => theme.spacing.oneAndHalf};
  &:hover {
    background-color: ${({theme, isDisabled}) => !isDisabled && theme.colors.utility.highlight};
  }
`

const SelectOption = ({
  innerRef,
  innerProps,
  data,
  selectProps,
  label,
  isFocused,
  isDisabled,
  iconAfter,
  useBody
}: {
  innerRef: any
  innerProps: any
  data: any
  selectProps: any
  label: string
  isFocused: boolean
  isDisabled: boolean
  iconAfter?: IconTypes
  useBody?: boolean
}) => {
  const {
    components: {OptionIcon, OptionLabel},
    labelKey
  } = selectProps

  const labelText = OptionLabel ? <OptionLabel {...data} /> : label || data[labelKey]

  return (
    <FlexRow ref={innerRef} {...innerProps} isFocused={isFocused} isDisabled={isDisabled} alignItems="center">
      {OptionIcon && <OptionIcon {...data} />}
      <Flex alignItems="center" justifyContent="space-between" width="100%">
        {useBody ? <Body small>{labelText}</Body> : <StyledLabel>{labelText}</StyledLabel>}
        {iconAfter && <Icon icon={iconAfter} size={11} />}
      </Flex>
    </FlexRow>
  )
}

export default SelectOption
